import { cn } from '@lib/cn';

import type { ReactNode } from 'react';

/** Hand-rolled table cells — the kit has no table primitive (see `ClientsPage`). */

export function Th({ children, className }: { children?: ReactNode; className?: string }) {
    return (
        <th
            className={cn(
                'whitespace-nowrap border-b border-line-subtle px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wide text-content-muted',
                className,
            )}
        >
            {children}
        </th>
    );
}

export function Td({ children, className }: { children?: ReactNode; className?: string }) {
    return (
        <td
            className={cn('border-b border-line-subtle px-4 py-3 align-top text-[13px]', className)}
        >
            {children}
        </td>
    );
}

/** "X of N" over a thin bar, as the Feature Activation table draws it. */
export function ProgressBar({ label, percent }: { label: string; percent: number | null }) {
    return (
        <div>
            <div className="mb-1.5 text-[13px] font-semibold text-content">{label}</div>
            {percent !== null && (
                <div
                    role="progressbar"
                    aria-valuenow={Math.round(percent)}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-label={label}
                    className="h-1.5 w-full overflow-hidden rounded-full bg-surface-inset"
                >
                    <div
                        className="h-full rounded-full bg-brand transition-[width]"
                        style={{ width: `${String(percent)}%` }}
                    />
                </div>
            )}
        </div>
    );
}
